import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import ReactDOM from 'react-dom/client';
import { CookiesProvider } from "react-cookie"
import App from "./app";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/auth-user";
import { QueryProvider } from "./context/QueryProvider";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<CookiesProvider defaultSetOptions={{ path: "/" }}>
		<BrowserRouter>
			<QueryParamProvider adapter={ReactRouter6Adapter}>
				<AuthProvider>
					<QueryProvider>
						<App />
					</QueryProvider>
				</AuthProvider>
			</QueryParamProvider>
		</BrowserRouter>
	</CookiesProvider>
);

